import { api } from "./api";

/**
 * Booking & Condition Record V1: durable rental receipt + condition record.
 * Two auth contexts hit the same customer-safe backend aggregation
 * (`bookings/condition_record_service.py`) via two different routes, same
 * pattern as `lib/vehicleDetails.js`.
 */
export async function getConfirmationTokenRecord(token) {
  const r = await api.get(`/public/confirm/${token}/condition-record`);
  return r.data;
}

export async function getPortalBookingRecord(bookingId) {
  const r = await api.get(`/customer/bookings/${bookingId}/condition-record`);
  return r.data;
}

export async function getConfirmationTokenRecordPhoto(token, photoId) {
  const r = await api.get(`/public/confirm/${token}/condition-record/photos/${photoId}`);
  return r.data;
}

export async function getPortalBookingRecordPhoto(bookingId, photoId) {
  const r = await api.get(`/customer/bookings/${bookingId}/condition-record/photos/${photoId}`);
  return r.data;
}
